import { render, staticRenderFns } from "./UserDetailPage.vue?vue&type=template&id=3262300a&scoped=true"
import script from "./UserDetailPage.vue?vue&type=script&lang=js"
export * from "./UserDetailPage.vue?vue&type=script&lang=js"
import style0 from "./UserDetailPage.vue?vue&type=style&index=0&id=3262300a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3262300a",
  null
  
)

export default component.exports